import { makeStyles } from '@material-ui/core/styles';

export const CorreosToolTipStyles = makeStyles((theme) => ({
    customTooltip: {
        backgroundColor: "#002453",
    }
}));